// Terim seti: klinik (varsayılan). Anahtarlar wellness.js ile birebir aynı olmalı.
const clinical = {
  patient: "Hasta",
  patients: "Hastalar",
  patientGen: "Hastanın",
  patientDat: "Hastaya",
  patientAcc: "Hastayı",
  patientLoc: "Hastada",
  patientLower: "hasta",
  patientsLower: "hastalar",
  patientGenLower: "hastanın",
  patientDatLower: "hastaya",
  patientAccLower: "hastayı",
  patientAblLower: "hastadan",
  patientLocLower: "hastada",
  patientIns: "Hastayla",
  patientInsLower: "hastayla",
  patientYourAccLower: "hastanızı",
  patientsGen: "Hastaların",
  exam: "Muayene",
  examLower: "muayene",
  examAcc: "Muayeneyi",
  examLoc: "muayenede",
  examStart: "Muayeneyi başlat",
  examComplete: "Muayeneyi Tamamla",
  inExam: "Muayenede",
  examDo: "Muayene Et",
  doctor: "Doktor",
  doctorLower: "doktor",
  doctorPossLower: "doktoru",
  firstVisit: "İlk muayene",
  firstVisitTitle: "İlk Muayene",
  followUp: "Kontrol",
  complaint: "Şikayet",
  patientNo: "Hasta No",
};
export default clinical;
